import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlay = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4125_165794",
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 12,
			height: 12,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 12,
				height: 12,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", { mask: "url(#mask0_4125_165794)" }),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_4125_165794)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M10.6221 5.3392L3.05415 1.0887C2.57773 0.822149 2 1.18328 2 1.75078V10.2489C2 10.8164 2.57773 11.1776 3.05415 10.9081L10.6221 6.6605C11.126 6.37675 11.126 5.62295 10.6221 5.3392Z",
				fill: "#7683A8"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4125_165794",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 9,
				height: 10,
				fill: "white",
				transform: "translate(2 1)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPlay);
export default ForwardRef;
